<template>
  <div class="submit-worker-details">
    <div v-if="!comparingMode">
      <span class="tag mb-2" v-if="showCandidateName(application)"
        >C-{{ worker.id }}</span
      >
      <div class="d-flex align-end">
        <h2>{{ candidate }}</h2>
        <h3
          v-if="showCandidateName(application) && booking.anonymiseApplications"
          class="ml-2 secondary-text"
        >
          ({{ `Candidate ${application.id}` }})
        </h3>
      </div>

      <div class="text-primary mb-5 font-weight-bold" v-if="showContactDetails">
        {{ worker.email }} | <a :href="tel">{{ worker.phone }}</a>
      </div>
    </div>
    <CandidateDetails
      :application="application"
      :comparingMode="comparingMode"
    />
  </div>
</template>

<script>
import CandidateDetails from "@/views/bookings/BookingDetails/CandidateDetails/components/CandidateDetails";
import { getFullName, showCandidateName } from "@/utils/users";
import { GET_CURRENT_BOOKING } from "@/store/modules/bookings/getters";
import { createNamespacedHelpers } from "vuex";
import { BOOKINGS_NAMESPACE } from "@/store/modules/bookings/actions";

const { mapGetters } = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  name: "CandidateDetailsDesktop",
  components: {
    CandidateDetails
  },
  data() {
    return {
      editReferenceNumber: false,
      editAwrStatus: false,
      files: [],
      workerAddress: null,
      isAddingComment: false
    };
  },
  computed: {
    ...mapGetters({
      booking: GET_CURRENT_BOOKING
    }),
    worker() {
      return this.application.user || {};
    },
    candidate() {
      return showCandidateName(this.application)
        ? getFullName(this.worker)
        : `Candidate ${this.application.id}`;
    },
    showContactDetails() {
      return (
        (this.worker.email || this.worker.phone) &&
        showCandidateName(this.application)
      );
    },
    tel() {
      return `tel:${this.worker.phone}`;
    },
    mailto() {
      return `mailto:${this.worker.email}`;
    }
  },
  props: {
    comparingMode: Boolean,
    application: Object
  },
  methods: {
    showCandidateName
  }
};
</script>

<style lang="scss">
.submit-worker-details {
  padding-bottom: 150px;
  overflow: auto;
  top: 0;
  background-color: $white;

  > div {
    margin-bottom: 1rem;
  }

  h3 {
    margin-bottom: 0;
  }

  .tag {
    color: $secondary-text;
    @include mono;
  }

  .reference-number {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
}
</style>
